import React, { Component } from 'react'
import styled from 'styled-components'
import { injectState } from 'freactal'
import Button from '../../components/Button'
import ScrollingDialog from '../../components/ScrollingDialog'

const Textarea = styled.textarea`
  height: 40vh;
  width: 100%;
  box-sizing: border-box;
`

class UnitNotesModal extends Component {
  state = {
    notes: this.props.state.unitNotes,
  }
  componentWillReceiveProps({ state: { unitNotes } }) {
    if (this.state.notes !== unitNotes) {
      this.setState({ notes: unitNotes })
    }
  }
  handleChange = ({ target }) => {
    this.setState({ notes: target.value })
  }
  propegateChange = () => {
    this.props.effects.handleUnitNotesChange(this.state.notes)
  }
  render() {
    const {
      state: { unit: { title } },
      effects: { handleUnitNotesSave, handleUnitNotesModalClose },
    } = this.props
    const { notes } = this.state
    return (
      <ScrollingDialog
        title={`${title} - Notes`}
        actions={[
          <Button key="0" onClick={handleUnitNotesModalClose}>Cancel</Button>,
          <Button key="1" onClick={handleUnitNotesSave}>Save</Button>,
        ]}>
        <Textarea
          onBlur={this.propegateChange}
          onChange={this.handleChange}
          value={notes}
        />
      </ScrollingDialog>
    )
  }
}

export default injectState(UnitNotesModal)



// WEBPACK FOOTER //
// ./src/Units/components/UnitNotesModal.js